<template>
  <nav class="navbar navbar-expand-lg navbar-light text-white">
    <div class="container">
      <router-link class="navbar-brand" :to="{ name: 'home' }">
        <img :src="require('@/assets/logo.svg')" alt="Logo" class="logo" />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'home' }">
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'about' }">
              About
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#skills"> Skills </a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'projects' }"
              >Portfolio</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'experience' }">
              Experience
            </router-link>
          </li>
        </ul>
        <div class="social-icons">
          <li>
            <a :href="socialLinks.facebook" target="_blank">
              <font-awesome-icon :icon="['fab', 'facebook-f']" />
            </a>
          </li>
          <li>
            <a :href="socialLinks.twitter" target="_blank">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
          </li>
          <li>
            <a :href="socialLinks.github" target="_blank">
              <font-awesome-icon :icon="['fab', 'github']" />
            </a>
          </li>
          <li>
            <a :href="socialLinks.linkedin" target="_blank">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
          </li>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

library.add(faTwitter, faFacebookF, faGithub, faLinkedinIn);

export default {
  name: "AppNavbar",
  data() {
    return {
      socialLinks: {
        facebook: "https://www.facebook.com/akaKaynite",
        twitter: "https://twitter.com/akaKaynite",
        github: "https://github.com/Kaynite",
        linkedin: "https://www.linkedin.com/in/kareemsaber/",
      },
    };
  },
};
</script>
